// @flow
import { createSelector } from "reselect"
import type { InputSelector } from "reselect"

import type { Modals } from "../../records/Modals"

const modalsSelector = state => state.modals

type State = { +modals: Modals }

export const isLoginOpened: InputSelector<State, any, boolean> = createSelector(
  [modalsSelector],
  modals => Boolean(modals.get("login")),
)

export default isLoginOpened
